/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModalContext, ModalManagerContext } from '@/context/modalProvider'
import { useContext, useEffect, useState } from 'react'

type UseModal = {
  openModal: (data?: any) => void
  closeModal: () => void
}

export const useModalManager = (): ModalContext | null => {
  const context = useContext(ModalManagerContext)

  return context
}

export const useModal = (
  id: string,
  props?: Record<string, unknown | undefined>
): UseModal => {
  const [currentProps, setCurrentProps] = useState(props)
  const modalManager = useModalManager()
  if (!modalManager) {
    throw new Error('useModal must be used within a ModalProvider')
  }

  const { openModal, closeModal, updateModal } = modalManager

  useEffect(() => {
    // Ensure there are props to pass to the modal
    if (!props || !props.data || Object.keys(props.data).length === 0) return

    // Update the current props only if they have changed
    // This prevents unnecessary updates and re-renders
    if (JSON.stringify(props) === JSON.stringify(currentProps)) return

    setCurrentProps(props)
    updateModal(id, props)
  }, [currentProps, id, props, updateModal])

  return {
    openModal: (data?: any) => openModal(id, { data, ...props }),
    closeModal: () => closeModal(id)
  }
}
